import React, { useEffect, useState, useRef } from 'react';

import { SVGIcon } from '@uikit/old/Icon/Icon';
import { Button } from '@uikit/Form/Button/Button';
import getFileSizeString from '@utils/getFileSizeString';

import './AttachFileZone.scss';

function AttachFileZone({ onChange }: { onChange: (files: File[]) => void }): JSX.Element {
  const inputRef = useRef(null);
  const [files, setFiles] = useState([]);
  const [isInited, setIsInited] = useState(false);

  useEffect(() => {
    if (!isInited) {
      setIsInited(true);
    } else {
      onChange(files);
    }
  }, [files]);

  const handleFiles = (fileList) => {
    const newFile = [Array.from(fileList)[0]];
    setFiles((prev) => [...newFile]);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    handleFiles(e.dataTransfer.files);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const cleanFiles = () => {
    setFiles([]);
    onChange([]);
  };

  return (
    <div>
      <div
        role="button"
        tabIndex={0}
        className="attach-zone"
        onClick={() => inputRef.current.click()}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            inputRef.current.click();
          }
        }}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
      >
        <SVGIcon icon="picture" />
        <p>Attach screenshot or file</p>
      </div>

      <input
        accept=".jpg,.jpeg,.png,.webp,.avif,.gif"
        ref={inputRef}
        type="file"
        hidden
        data-testid="attach-file-input"
        onChange={(e) => handleFiles(e.target.files)}
      />

      <div className="file-list">
        {files.map((file) => (
          <div className="file-list__item" key={`${file.name}-${file.size}`}>
            <SVGIcon color="#525979" icon="fileBlank" />
            <div className="file-list__item-info">
              <span className="file-name">{file.name}</span>
              <span className="file-size">{getFileSizeString(file.size)}</span>
            </div>
            <Button
              type="ghost"
              leftIcon="crossBlack"
              colorIcon="#8E95AA"
              iconSize={15}
              onClick={cleanFiles}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default AttachFileZone;
